import { npsModalActionTypes } from './Constants';

const initialState = {
	open: false,
	submitLoading: false,
};

export default function npsModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case npsModalActionTypes.TOGGLE_NPS_MODAL:
			return {
				...state,
				...data,
			};
		case npsModalActionTypes.SUBMIT_NPS_MODAL:
			return {
				...state,
				submitLoading: true,
			};
		case npsModalActionTypes.SUBMIT_NPS_MODAL_SUCCESS:
			return {
				...state,
				...data,
				submitLoading: false,
			};
		case npsModalActionTypes.SUBMIT_NPS_MODAL_ERROR:
			return {
				...state,
				submitLoading: false,
			};
		case npsModalActionTypes.CLEAR_NPS_MODAL_STATE:
			return initialState;
		default:
			return state;
	}
}
